import React from 'react';
import './App.css';
import TableManager from './components/TableManager';

function App() {
  return (
    <div className="App">
      <TableManager />
    </div>
  );
}

export default App;
